/**
 * ConnectPayoutsPanel — solver-side Stripe Connect onboarding entry.
 *
 * Rendered in the Profile page's Researcher section. Hides itself when
 * the user is already onboarded and payouts are enabled.
 *
 *   Not started  → "Set up payouts" button → opens Stripe hosted onboarding
 *   In progress  → "Continue setup" button → re-opens onboarding link
 *   Ready        → "Payouts ready" badge
 */
import { useEffect, useState } from 'react'
import { api } from '../../services/api.js'

export default function ConnectPayoutsPanel() {
  const [status, setStatus] = useState(null)
  const [busy, setBusy]     = useState(false)

  useEffect(() => {
    api.get('/connect/status').then(setStatus).catch(() => {})
  }, [])

  async function start() {
    setBusy(true)
    try {
      const { onboarding_url } = await api.post('/connect/start', {})
      window.location.href = onboarding_url
    } catch (e) {
      setBusy(false)
    }
  }

  if (!status) return null

  const ready = status.connected && status.payouts_enabled

  return (
    <div className="connect-panel">
      <div className="connect-panel__head">
        <span className="connect-panel__label">Bounty payouts</span>
        {ready
          ? <span className="connect-panel__pill connect-panel__pill--ok">Ready</span>
          : status.connected
            ? <span className="connect-panel__pill connect-panel__pill--warn">Onboarding incomplete</span>
            : <span className="connect-panel__pill">Not set up</span>}
      </div>
      {!ready && (
        <>
          <p className="connect-panel__copy">
            To receive payouts when your mystery solutions are approved, set up a
            Stripe payouts account. Stripe handles ID verification and tax forms;
            Genealogic never sees your bank details.
          </p>
          <button className="btn btn-primary btn-sm" onClick={start} disabled={busy}>
            {busy
              ? 'Opening Stripe…'
              : status.connected ? 'Continue setup →' : 'Set up payouts →'}
          </button>
        </>
      )}
    </div>
  )
}
